import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "info"]
  static values = { url: String }

  connect() {
    this.loadOrgInfo()
  }

  changed() {
    this.loadOrgInfo()
  }

  loadOrgInfo() {
    const orgId = this.selectTarget.value
    if (!orgId) {
      this.infoTarget.innerHTML = '<p class="text-grey">Select an assessor organisation to see details.</p>'
      return
    }

    const activeTab = document.querySelector('input[name="active_tab"]')?.value
    const basePath = window.location.pathname
    const returnTo = encodeURIComponent(activeTab ? `${basePath}?active_tab=${activeTab}` : basePath)
    fetch(`${this.urlValue}?assessor_org_id=${orgId}&return_to=${returnTo}`, {
      headers: { 'Accept': 'text/html' }
    })
      .then(response => response.text())
      .then(html => { this.infoTarget.innerHTML = html })
      .catch(() => {
        this.infoTarget.innerHTML = '<p class="text-grey">Could not load organisation info.</p>'
      })
  }
}
